export default {
  MuiCheckbox: {
    styleOverrides: {
      root: {
        padding: '0px',
        '&.MuiCheckbox-root > svg': { fontSize: '18px' },
        '&.Mui-checked': {
          color: '#0F62FE' // 勾選時為藍色
        }
      }
    }
  }
};
